module.exports = __webpack_public_path__ + "img/9.769ed087.jpg";